import React from "react";
import { Grid } from "@mantine/core";
import styles from "./styles.module.css";

interface AccordionTwoColumnGridProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
}

const AccordionTwoColumnGrid: React.FC<AccordionTwoColumnGridProps> = ({ leftContent, rightContent }) => {
  return (
    <Grid>
      <Grid.Col className={styles.leftContent} span={4} py={50}>
        {leftContent}
      </Grid.Col>
      <Grid.Col className={styles.rightContent} span={8} py={45}>
        {rightContent}
      </Grid.Col>
    </Grid>
  );
};

export default AccordionTwoColumnGrid;
